<template>
  <div>
  <Card>
      <tables search-place="top" v-model="tableData" :columns="columns"/>
  </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getLunList } from '@/api/emc'
export default {
  name: 'LunList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: 'ID', key: 'id', align: 'center' },
        { title: 'name', key: 'name', align: 'center' },
        { title: 'sizeTotal', key: 'sizeTotal', align: 'center' },
        { title: 'sizeAllocated', key: 'sizeAllocated', align: 'center' },
        { title: 'pool', key: 'pool', align: 'center' },
        // { title: 'model', key: 'model', align: 'center' },
        // { title: 'size', key: 'size', align: 'center' },
        // { title: 'version', key: 'version', align: 'center' },
        { title: 'descriptions', key: 'descriptions', align: 'center' }
      ],
      tableData: [],
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  watch: {
  },
  methods: {
    getLunList () {
      getLunList().then(res => {
        this.tableData = res.data.data
        this.count = res.data.data.count
      })
    },
    searchReset () {
      this.searchForm.name = null
    }
  },
  mounted: function () {
    this.getLunList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
.ivu-input[disabled], fieldset[disabled] .ivu-input {
    background-color: #f3f3f3;
    opacity: 1;
    cursor: not-allowed;
    color: #666;
}
</style>
